import * as React from 'react';
import { toast } from 'sonner';

import { Campo } from '@/componentes/campo';
import { Button } from '@/componentes/ui/button';
import { Input } from '@/componentes/ui/input';
import { mensagemDoErro, useAlterarEmailDaEmpresa } from '@/dados';

import { Capitulo } from './ficha';

/* Trocar o e-mail do cadastro.
 *
 * É o único campo que o painel escreve. Não é o e-mail de login: aquele é
 * credencial, e trocá-lo por aqui seria poder redirecionar o acesso de
 * qualquer conta. Este é a chave que permite ao dono reivindicar o CNPJ, e
 * digitado errado ninguém mais consegue corrigi-lo. */
export function Email({ id, email }: { id: string; email: string }) {
  const [valor, setValor] = React.useState(email);
  const alterar = useAlterarEmailDaEmpresa(id);
  const limpo = valor.trim();

  const enviar = (evento: React.FormEvent) => {
    evento.preventDefault();
    if (limpo === email) return;
    alterar.mutate(limpo, { onSuccess: () => toast.success('E-mail do cadastro alterado.') });
  };

  return (
    <Capitulo
      titulo="E-mail do cadastro"
      descricao="É a chave que permite ao dono reivindicar este CNPJ. Não é o e-mail de login."
    >
      <form onSubmit={enviar} className="flex flex-wrap items-start gap-3">
        <Campo
          rotulo="E-mail"
          className="min-w-0 flex-1"
          erro={alterar.isError ? mensagemDoErro(alterar.error) : undefined}
        >
          {(atributos) => (
            <Input
              {...atributos}
              type="email"
              value={valor}
              onChange={(evento) => setValor(evento.target.value)}
            />
          )}
        </Campo>
        <Button type="submit" className="mt-6" disabled={limpo === email || alterar.isPending}>
          {alterar.isPending ? 'Salvando' : 'Salvar'}
        </Button>
      </form>
    </Capitulo>
  );
}
